import { render, staticRenderFns } from "./CategoryOverview.vue?vue&type=template&id=679a7949&scoped=true&"
import script from "./CategoryOverview.vue?vue&type=script&lang=js&"
export * from "./CategoryOverview.vue?vue&type=script&lang=js&"
import style0 from "./CategoryOverview.vue?vue&type=style&index=0&id=679a7949&scoped=true&lang=scss&"
import style1 from "./CategoryOverview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679a7949",
  null
  
)

export default component.exports